import React, { use, useEffect, useRef, useState } from 'react'
import styles from './Contacts.module.css'
import { useNavigate } from 'react-router-dom'

export type ContactsProps = {
    setNavBackground: React.Dispatch<React.SetStateAction<boolean>>;
}

const Contacts = (props: ContactsProps) => {
    const navigate = useNavigate()

    const [name, setName] = useState('')
    const [lastName, setLastName] = useState('')
    const [about, setAbout] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')
    const [checkboxChecked, setCheckboxChecked] = useState(false)

    useEffect(() => {
        props.setNavBackground(true);
    }, []);

    const handleCheckboxClick = async (e: React.MouseEvent<HTMLLabelElement>) => {
        e.preventDefault()

        setError('')
        setSuccess('')

        // VERY IMPORTANT: wait until internal grecaptcha is actually ready
        try {
            setCheckboxChecked(true)
        } catch (err) {
            console.error('Erro no executeAsync após reload:', err)
            setError('Erro ao validar. Tente novamente.')
        }
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        setError('')
        setSuccess('')

        const formData = new FormData()
        formData.append('name', name)
        formData.append('lastName', lastName)
        formData.append('about', about)
        formData.append('email', email)
        formData.append('message', message)
        formData.append('phone', phone)

        try {
            const res = await fetch('https://sazuli.pt/contact.php', {
                method: 'POST',
                body: formData,
            })

            if (res.ok) {
                setSuccess('A mensagem foi enviada com sucesso!')
                setName('')
                setLastName('')
                setAbout('')
                setEmail('')
                setMessage('')
                setPhone('')
                setCheckboxChecked(false)
            } else {
                setName('')
                setLastName('')
                setAbout('')
                setEmail('')
                setMessage('')
                setPhone('')
                setCheckboxChecked(false)
                if (res.status === 429) {
                    setError('Estás a enviar muitas mensagens. Por favor aguarde.')
                } else {
                    setError('Não foi possível enviar a mensagem.')
                }
            }
        } catch {
            setError('Não foi possível enviar a mensagem.')
        }
    }


    useEffect(() => {
        if (error) {
            setSuccess('')
        }
    }, [error]);

    const handleTermos = (e: React.MouseEvent<HTMLSpanElement>) => {
        e.stopPropagation(); // <-- evita disparar o clique do label
        navigate("/politica-de-privacidade");
    }

    return (
        <div className={styles.container}>
            <div className={styles.items}>
                <div className={styles.item}>
                    <div className={styles.form}>
                        <span className={styles.title}>Fale connosco</span>
                        <div className={styles.title_desc}>
                            <span className={styles.subtitle}>De que forma podemos ajudá-los?</span>
                            <span className={styles.desc}>Cada mensagem conta. Escreva-nos e faremos o possível para ajudar. </span>
                        </div>
                        <form className={styles.formContent} onSubmit={handleSubmit}>
                            <div className={styles.itemInput}>
                                <label htmlFor="firstName">Primeiro Nome</label>
                                <input type="text" id="firstName" required value={name} onChange={(e) => setName(e.target.value)} />
                            </div>
                            <div className={styles.itemInput}>
                                <label htmlFor="lastName">Último Nome</label>
                                <input type="text" id="lastName" required value={lastName} onChange={(e) => setLastName(e.target.value)} />
                            </div>
                            <div className={styles.itemInput}>
                                <label htmlFor="email">Email</label>
                                <input type="text" id="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            <div className={styles.itemInput}>
                                <label htmlFor="assunto">Assunto</label>
                                <input type="text" id="assunto" required value={about} onChange={(e) => setAbout(e.target.value)} />
                            </div>
                            <div className={styles.itemInput}>
                                <label htmlFor="mensagem">Mensagem</label>
                                <textarea
                                    name="mensagem"
                                    required
                                    id="mensagem"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                ></textarea>
                                <label className={styles.checkboxContainer}>
                                    <input type="checkbox" checked={checkboxChecked} readOnly />
                                    <span className={styles.customCheckbox} onClick={handleCheckboxClick}></span>
                                    <span onClick={handleTermos}>
                                        Li e aceito a{' '}
                                        <span className={styles.bold}>
                                            Política de Privacidade
                                        </span>{' '}
                                        da SAZULI
                                    </span>
                                </label>
                            </div>

                            {/* Honeypot field */}
                            <input type="text" name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} style={{ display: 'none' }} autoComplete="off" />

                            <div className={styles.itemInput}>
                                {error && <p style={{ color: 'red' }}>{error}</p>}
                                {success && <p style={{ color: 'green' }}>{success}</p>}
                            </div>
                            <div className={styles.itemInput}>
                                <button className={styles.btn} type="submit">
                                    Enviar Mensagem
                                </button>
                            </div>
                        </form>
                    </div>
                    <div className={styles.companyInfo}>
                        <div className={styles.itemInfo}>
                            <span className={styles.infoTitle}>Sede e Exposição</span>
                            <span className={styles.infoDesc}>Zona Industrial de Pinhal Basto 4615-669 Lixa, Portugal</span>
                        </div>
                        <div className={styles.itemInfo}>
                            <span className={styles.infoTitle}>Horário</span>
                            <div className={styles.infoGap}>
                                <div className={styles.infoDesc}>
                                    <span>Segunda a Sexta-feira</span>
                                    <span>08:30-12:30h | 14:00-19:00h</span>
                                </div>
                                <br />
                                <div className={styles.infoDesc}>
                                    <span>Sábados</span>
                                    <span>08:30-12:30h| 14:00-19:00h</span>
                                </div>
                                <br />
                                <div className={styles.infoDesc}>geral@sazuli.pt</div>
                                <br />
                                <div className={styles.phone}>
                                    <span className={styles.infoDesc}>255 490 460</span>
                                    <span className={styles.infoDesc}>916 189 052</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${styles.item} ${styles.maps}`}>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d16944.006056177546!2d-8.160233736056206!3d41.34590630619431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd24eaed69a10faf%3A0x2d9238335cc9bcd5!2sN101-4%2C%20Macieira%20da%20Lixa!5e0!3m2!1spt-PT!2spt!4v1749484826685!5m2!1spt-PT!2spt"
                        style={{ border: "0" }}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Sazuli Location Map"
                    ></iframe>
                </div>
            </div>
        </div>
    )
}

export default Contacts
